/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Set_As_Track_2Inputs */



/**
* | output |
* | --- |
* | "Set As Track 2" |
*
* @param {Event_Group_Options_Set_As_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_set_as_track_2 = /** @type {((inputs?: Event_Group_Options_Set_As_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Set_As_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définir comme piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als Track 2 festlegen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta come traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить как трек 2")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer como pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置为轨道 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック2として設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक 2 के रूप में सेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definir como faixa 2")
	return /** @type {LocalizedString} */ ("Set As Track 2")
});